import type { ReactElement } from 'react';

import { BREAKPOINTS, useMediaListener } from '@xing-com/util';

import { PageTitleHeader } from './page-title.styled';

export const PageTitle = (): ReactElement => {
  const matchedMedia = useMediaListener();
  const isSmallScreen = matchedMedia === BREAKPOINTS.handheld;

  /*TODO: add i18n translation in WFS-1666*/
  const headerCopy = isSmallScreen
    ? 'Mitgliedschaften erkunden'
    : 'Bring Deine Karriere schneller voran.';

  return (
    <PageTitleHeader size="medium" noMargin>
      {headerCopy}
    </PageTitleHeader>
  );
};
